import { render } from "./EditInfoPage.vue?vue&type=template&id=71f31740"
import script from "./EditInfoPage.vue?vue&type=script&lang=js"
export * from "./EditInfoPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nutsudaploysopon/Desktop/DevFinite/Octopus Co.,Ltd./Ncare/NCare-WebApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__